// extracted by mini-css-extract-plugin
export default {"root":"link_root__VYpVa"};